/**
 * Desteklenen diller — yeni dil eklemek için buraya bir satır ekle ve
 * src/i18n/locales/<kod>/ altına tr klasöründeki JSON dosyalarının çevirilerini koy.
 * Ayrıntılar: docs/I18N.md
 */
export const LANGUAGES = [
  { code: 'tr', short: 'TR', label: 'Türkçe', labelKey: 'languageTurkish', intl: 'tr-TR' },
  { code: 'en', short: 'EN', label: 'English', labelKey: 'languageEnglish', intl: 'en-US' },
];

/** Varsayılan ve kaynak dil (sunucu içerikleri bu dilde gelir). */
export const DEFAULT_LANGUAGE = 'tr';

/** Türkçe dışındaki dillerde eksik çeviri olursa önce bu dile düşülür. */
export const FALLBACK_LANGUAGE = 'en';

export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);

export function normalizeLanguage(code) {
  const base = String(code || '').toLowerCase().split('-')[0];
  return LANGUAGE_CODES.includes(base) ? base : DEFAULT_LANGUAGE;
}

export function intlLocaleFor(code) {
  const lang = LANGUAGES.find((l) => l.code === normalizeLanguage(code));
  return lang ? lang.intl : 'tr-TR';
}
